import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex flex-center flex-wrap justify-content-between my-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Status Permohonan Perkhidmatan", -1)
const _hoisted_4 = {
  class: "d-flex flex-center",
  role: "group",
  "aria-label": "Filter group"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: /*#__PURE__*/_normalizeClass(['btn', 'btn-perkhidmatan', 'text-white', 'mx-2'])
}, " Perkhidmatan ", -1)
const _hoisted_6 = { class: "row g-5" }
const _hoisted_7 = {
  key: 0,
  class: "card mb-5 d-flex align-items-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-body fs-5 fw-bolder" }, " Tiada Rekod Permohonan Perkhidmatan ", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_11 = {
  class: "nav flex-column nav-pills me-3",
  id: "v-pills-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_12 = ["id", "data-bs-target", "onClick"]
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "d-flex align-items-center mb-2" }
const _hoisted_15 = { class: "badge border border-1 border-tertiary text-reset me-2" }
const _hoisted_16 = { class: "badge border border-1 border-tertiary text-reset me-2" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-outline penempatan me-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ms-auto w-10px h-10px bg-success rounded-circle" }, null, -1)
const _hoisted_19 = { class: "text-gray-600" }
const _hoisted_20 = { class: "text-gray-600 d-flex" }
const _hoisted_21 = {
  class: /*#__PURE__*/_normalizeClass([
                  'd-flex',
                  'text-dark',
                  'rounded-2',
                  'p-2',
                  'bg-light-success',
                ])
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Status: ")
], -1)
const _hoisted_23 = {
  key: 0,
  class: "fw-bolder text-gray-600"
}
const _hoisted_24 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-save-fill text-primary",
  style: {"font-size":"18px"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bolder mx-2" }, "Muat Turun Surat Siaran", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 2,
  class: "col-md-8"
}
const _hoisted_30 = { class: "card" }
const _hoisted_31 = {
  key: 0,
  class: "card-body"
}
const _hoisted_32 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "badge border border-1 border-tertiary text-reset me-2" }
const _hoisted_35 = { class: "badge border border-1 border-tertiary text-reset me-2" }
const _hoisted_36 = { class: "ms-auto mb-2" }
const _hoisted_37 = {
  key: 0,
  class: "me-2"
}
const _hoisted_38 = {
  key: 1,
  class: "me-2"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-success btn-sm disabled" }, " Kemaskini / Hantar Permohonan ", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 2,
  class: "me-2"
}
const _hoisted_42 = {
  key: 3,
  class: "me-2"
}
const _hoisted_43 = { class: "d-flex bg-gray-300 text-dark rounded-2 p-2 bg-light-success" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Status: ")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Butir-butir Perkhidmatan", -1)
const _hoisted_46 = { class: "table" }
const _hoisted_47 = { class: "border-bottom" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Jawatan Hakiki:", -1)
const _hoisted_49 = { style: {"text-transform":"uppercase"} }
const _hoisted_50 = { class: "border-bottom" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Gred Jawatan Semasa:", -1)
const _hoisted_52 = { style: {"text-transform":"uppercase"} }
const _hoisted_53 = { class: "border-bottom" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Tarikh Lantikan Ke Perkhidmatan Sekarang:", -1)
const _hoisted_55 = { style: {"text-transform":"uppercase"} }
const _hoisted_56 = { class: "border-bottom" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Tarikh Memangku:", -1)
const _hoisted_58 = { style: {"text-transform":"uppercase"} }
const _hoisted_59 = { class: "border-bottom" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Kementerian:", -1)
const _hoisted_61 = { style: {"text-transform":"uppercase"} }
const _hoisted_62 = { class: "border-bottom" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Jabatan Bertugas Semasa:", -1)
const _hoisted_64 = { style: {"text-transform":"uppercase"} }
const _hoisted_65 = { class: "border-bottom" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Alamat Pejabat:", -1)
const _hoisted_67 = { style: {"text-transform":"uppercase"} }
const _hoisted_68 = { class: "border-bottom" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Negeri:", -1)
const _hoisted_70 = { style: {"text-transform":"uppercase"} }
const _hoisted_71 = { class: "border-bottom" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Poskod:", -1)
const _hoisted_73 = { class: "border-bottom" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Telefon Pejabat:", -1)
const _hoisted_75 = { class: "border-bottom" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "E-mel Ketua Jabatan:", -1)
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("h2", { class: "py-5" }, "Pilihan Penempatan", -1)
const _hoisted_79 = { class: "table" }
const _hoisted_80 = { class: "tbodyPenempatan" }
const _hoisted_81 = { class: "border-bottom" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Pilihan Penempatan Pertama:", -1)
const _hoisted_83 = { style: {"text-transform":"uppercase"} }
const _hoisted_84 = { class: "border-bottom" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Pilihan Penempatan Kedua:", -1)
const _hoisted_86 = { style: {"text-transform":"uppercase"} }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("h2", null, "Kenyataan Penempatan Kekosongan Semasa", -1)
const _hoisted_89 = { class: "table" }
const _hoisted_90 = { class: "tbodyPenempatan" }
const _hoisted_91 = { class: "border-bottom" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, "Penempatan Khas:", -1)
const _hoisted_93 = { style: {"text-transform":"uppercase"} }
const _hoisted_94 = {
  key: 1,
  class: "d-flex flex-center h-100"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1)
const _hoisted_96 = [
  _hoisted_95
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_link, {
          class: _normalizeClass(['btn', 'btn-peperiksaan-faded', 'mx-2']),
          to: { name: 'status-peperiksaan' }
        }, {
          default: _withCtx(() => [
            _createTextVNode("Peperiksaan")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.kenaikanPangkatMohonList.length < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        : _createCommentVNode("", true),
      (_ctx.kenaikanPangkatMohonList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kenaikanPangkatMohonList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(['card', 'mb-5', index == 0 ? 'active' : '']),
                  id: `v-pills-${index}-tab`,
                  "data-bs-toggle": "pill",
                  "data-bs-target": `#v-pills-${index}`,
                  type: "button",
                  role: "tab",
                  "aria-selected": "true",
                  onClick: ($event: any) => (_ctx.getDetails(item.id), (_ctx.selectedTab = index))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.borangTypeLabel(item.naik_pangkat.kategori_permohonan)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, _toDisplayString(item.naik_pangkat.tahun), 1)
                      ]),
                      (item.naik_pangkat.penempatan_khas == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", null, _toDisplayString(item.naik_pangkat.penempatan_khas == 1
                      ? "Penempatan Khas"
                      : ""), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_18
                    ]),
                    _createElementVNode("h3", null, _toDisplayString(item.naik_pangkat.tajuk), 1),
                    _createElementVNode("span", _hoisted_19, " Tarikh Iklan Dibuka Pada " + _toDisplayString(_ctx.formatDate(item.naik_pangkat.tarikh_permohonan_mula)), 1),
                    _createElementVNode("span", _hoisted_20, " Tarikh Tutup Permohonan " + _toDisplayString(_ctx.formatDate(item.naik_pangkat.tarikh_permohonan_tamat)), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("span", null, _toDisplayString(_ctx.mohonStatusLabel(
                    item.status_permohonan,
                    item.status_keputusan
                  )), 1)
                    ]),
                    (item.tarikh_kuatkuasa_keputusan)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_23, " Kuat kuasa pada: " + _toDisplayString(_ctx.formatDate(item.tarikh_kuatkuasa_keputusan)), 1))
                      : _createCommentVNode("", true),
                    (
                  [
                    'PRO',
                    'KNP_WA41_WA44',
                    'KNP_W19_W22',
                    'KNP_W22_W26',
                    'KNP_W26_W28',
                    'KNP_W29_W32',
                    'KNP_W32_W36',
                    'KNP_W36_W40',

                    'TBK1_W19_W22',
                    'TBK2_W22_W26',
                    'TBK1_W29_W32',
                    'TBK2_W32_W36',

                    'TBK1_H11_H14_PEMANDU',
                    'TBK1_H11_H14_PA',
                    'TBK1_N11_N14',
                    'TBK1_N19_N22_PKP',
                    'TBK1_N19_N22_PA',
                    'TBK1_W19_W22_PTKW',
                    'TBK1_N19_N22_PSP',
                    'TBK1_N19_N22_PTPO',
                    'TBK1_N29_N32_PSP',
                    'TBK1_N29_N32_PPT',

                    'TBK2_H14_H16_PEMANDU',
                    'TBK2_H14_H16_PA',
                    'TBK2_N14_N16',
                    'TBK2_N22_N26_PTPO',
                    'TBK2_N22_N26_PKP',
                    'TBK2_N22_N26_PA',
                    'TBK2_W22_W26_PTKW',
                    'TBK2_N22_N26_PSP',
                    'TBK2_N32_N36_PPT',
                    'TBK2_N32_N36_PSP',
                  ].indexOf(item.naik_pangkat?.jenis_permohonan) > -1 &&
                  ['BERJAYA', 'TIDAK_BERJAYA', 'CALON_SIMPANAN'].indexOf(
                    item.status_keputusan
                  ) > -1 &&
                  item.lampiran_surat_siaran_meta != null &&
                  item.lampiran_surat_siaran != 0
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("button", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (
                    _ctx.muatTurunSuratSiaran(item.lampiran_surat_siaran_meta)
                  ), ["prevent"]),
                            class: "btn w-100",
                            style: {"border":"1px solid","border-color":"#a8a8a8","background-color":"rgba(7, 143, 78, 0.1)"}
                          }, _hoisted_28, 8, _hoisted_25)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_12))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.kenaikanPangkatMohonList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.borangTypeLabel(
                      _ctx.butirPerkhidmatan.naik_pangkat?.kategori_permohonan ?? "-"
                    )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.butirPerkhidmatan.naik_pangkat?.tahun ?? "-"), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (_ctx.isShowBtnKemaskini(_ctx.butirPerkhidmatan))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _createElementVNode("button", {
                                class: "btn btn-success btn-sm",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sambungDraf(_ctx.butirPerkhidmatan?.naik_pangkat, _ctx.butirPerkhidmatan)))
                              }, " Kemaskini / Hantar Permohonan ")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowDisabledBtnKemaskini(_ctx.butirPerkhidmatan))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                          : _createCommentVNode("", true),
                        (_ctx.isShowBtnBatalMohon(_ctx.butirPerkhidmatan))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                              _createElementVNode("button", {
                                class: "btn btn-light-danger btn-sm",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => {
                      _ctx.mohon_id = _ctx.butirPerkhidmatan.id;
                      _ctx.batalPermohonan(_ctx.butirPerkhidmatan.id);
                    })
                              }, " Batal Permohonan ")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowBtnCetak(_ctx.butirPerkhidmatan))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                              _createElementVNode("button", {
                                class: "btn btn-light-warning btn-sm",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getLampiran(_ctx.butirPerkhidmatan.id)))
                              }, " Cetak ")
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.borangJenisLabel(
                  _ctx.butirPerkhidmatan.naik_pangkat?.jenis_permohonan ?? "-"
                )), 1),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("span", null, _toDisplayString(_ctx.mohonStatusLabel(
                  _ctx.butirPerkhidmatan.status_permohonan,
                  _ctx.butirPerkhidmatan.status_keputusan
                )), 1)
                    ]),
                    _hoisted_45,
                    _createElementVNode("table", _hoisted_46, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.butirPerkhidmatan.jawatan ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.butirPerkhidmatan.gred ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_53, [
                          _hoisted_54,
                          _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.formatDate(_ctx.butirPerkhidmatan.tarikh_lantikan_sekarang)), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_56, [
                          _hoisted_57,
                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.formatDate(
                        _ctx.butirPerkhidmatan.tarikh_memangku
                      ) ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_59, [
                          _hoisted_60,
                          _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.butirPerkhidmatan.kementerian?.nama_kementerian ??
                      _ctx.butirPerkhidmatan.pegawai?.kementerian_name ??
                      "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.butirPerkhidmatan.jabatan_bertugas_semasa ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.butirPerkhidmatan.bertugas_alamat ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.butirPerkhidmatan.bertugas_negeri?.nama_negeri ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_71, [
                          _hoisted_72,
                          _createElementVNode("td", null, _toDisplayString(_ctx.butirPerkhidmatan.bertugas_poskod ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("td", null, _toDisplayString(_ctx.butirPerkhidmatan.no_telefon_pejabat ?? "-"), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_75, [
                          _hoisted_76,
                          _createElementVNode("td", null, _toDisplayString(_ctx.butirPerkhidmatan.emel_ketua_jabatan ?? "-"), 1)
                        ])
                      ])
                    ]),
                    (
                _ctx.butirPerkhidmatan.naik_pangkat?.kategori_permohonan == 'PMK' &&
                _ctx.butirPerkhidmatan.naik_pangkat?.jenis_permohonan != 'IKHTISAS'
              )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.butirPerkhidmatan.penempatan_pertama_negeri != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("table", _hoisted_79, [
                                  _createElementVNode("tbody", _hoisted_80, [
                                    _createElementVNode("tr", _hoisted_81, [
                                      _hoisted_82,
                                      _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.butirPerkhidmatan.penempatan_pertama ?? "-") + ", " + _toDisplayString(_ctx.butirPerkhidmatan.penempatan_pertama_negeri
                            ?.nama_negeri ?? "-"), 1)
                                    ]),
                                    _createElementVNode("tr", _hoisted_84, [
                                      _hoisted_85,
                                      _createElementVNode("td", _hoisted_86, _toDisplayString(_ctx.butirPerkhidmatan.penempatan_kedua ?? "-") + ", " + _toDisplayString(_ctx.butirPerkhidmatan.penempatan_kedua_negeri
                            ?.nama_negeri ?? "-"), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.butirPerkhidmatan.penempatan_khas_negeri != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                _hoisted_88,
                                _createElementVNode("table", _hoisted_89, [
                                  _createElementVNode("tbody", _hoisted_90, [
                                    _createElementVNode("tr", _hoisted_91, [
                                      _hoisted_92,
                                      _createElementVNode("td", _hoisted_93, _toDisplayString(_ctx.butirPerkhidmatan.penempatan_khas_lokasi ?? "-") + ", " + _toDisplayString(_ctx.butirPerkhidmatan.penempatan_khas_poskod ?? "-") + ", " + _toDisplayString(_ctx.butirPerkhidmatan.penempatan_khas_negeri
                            ?.nama_negeri ?? "-"), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}